<template>
  <div>
    <div class="search-panel">
      <slot name="btn"></slot>
      <template>       
        <!-- <a-select  placeholder="请选择周期" v-model="periodId" showSearch :filterOption="filterOption"
                :style="{ width: '100%', maxWidth: '200px', marginRight: '10px' }">
                <a-select-option :value="item.id" v-for="(item, index) in periodItemList" :key="index">
                  {{ item.name}}</a-select-option>
              </a-select> -->
        <a-button class="search-item-com" type="primary" @click="searchQueryMy">查询</a-button>
      </template>
    </div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:'100%'}"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :rowSelection="selected?{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}:null"
      :loading="loading"
      @change="handleTableChange">
        <!-- <template slot="time" slot-scope="time">
          <a-range-picker valueFormat="YYYY-MM-DD" style="width:200px"/>
        </template> -->
        <span slot="action" slot-scope="text, record">
          <a @click="handleView(record)">查看</a>
        </span>
        <span slot="status" slot-scope="text, record, index">
          <status-tag :status="text"></status-tag>
        </span>
    </a-table>
  </div>
</template>

<script>
  import FormViewItem from '@/views/project/components/FormViewItem'
  import StatusTag from '@/views/project/patient/components/StatusTag'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction ,postAction} from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'WechatPatientReport',
    mixins: [JeecgListMixin],
    components: { FormViewItem,StatusTag },
    props:{      
      selected:{
        type:Boolean,
        default:false,
      },
      baseQuery:{
        type:Object,
        default:()=>{
          return {}
        },
      }
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        periodId:'',
        periodItemList:[],
        queryParam2:{},
        selectPeriodName:'',
        selectUserName:'',       
        columns: [  
        {
          title: '受试者编号',
          align: 'center',
          width: 80,
          ellipsis: true,
          dataIndex: 'patientNum',
        },
        {
          title: '受试者手机号',
          align: 'center',
          width: 80,
          ellipsis: true,
          dataIndex: 'patientPhone',
        },
        {
          title: '调查员姓名',
          align: 'center',
          width: 80,
          ellipsis: true,
          dataIndex: 'researcherName',
        },
        {
          title: '基线完成时间',
          align: 'center',
          width: 80,
          ellipsis: true,
          dataIndex: 'baseTime',
        },
      ],
        url:{
          list:'/patient/patient/wechatQueryPatient'
        },
        disableMixinCreated:true,
      }
    },
    mounted(){
      // this.resetSupperParams()
      // this.loadData()
       this.loadSearchData()
      //this.baseQueryParam = Object.assign({projectId:this.projectId,baseId:'1635892464123592705',periodId:this.periodId, checked:'0'},this.baseQuery)
    },
    methods:{
      loadSearchData(){
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
            // 确保数组有至少两个元素，然后选择第二项
            if(this.periodItemList && this.periodItemList.length >= 2){
              this.periodId = this.periodItemList[1].id
            }
          }
        })
      },
      loadDataCallback(){
        let that = this
        this.dataSource.forEach(function (item) {
          item.selectPeriodName = that.selectPeriodName
          item.selectUserName = that.selectUserName
        });
      },

      searchQueryMy(){
        this.baseQueryParam = Object.assign({projectId:this.projectId},this.baseQuery)
        this.searchQuery()
      },
      handleView(record){
        // this.$router.push({path:'/project/datacheck/checkform/'+record.id})
        this.$router.push({path:'/project/patient/registerview/'+record.id})
      },
     
     
      filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
     
      handleTableChange(pagination, filters, sorter) {
        console.log("filters:"+ filters)
        let filterParam = this.queryParam2        
        if(filters["groupName"]){
          // this.queryParam2.groupIdList = filters["groupName"]
          this.$set(filterParam,'groupIdList',filters["groupName"])
        }

        this.$set(this.queryParam,'supper',JSON.stringify(filterParam))
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
      },
      initFiltersValue(){        
        this.columns[4].children[2].defaultFilteredValue = [this.queryParam2.patientStatus]
      },
    }
  }
</script>

<style scoped lang="less">
  .search-panel{
    text-align: left;
    margin-bottom: 10px;
    padding: 10px;
  }
  .search-item-com{
    margin-left: 5px;
  }
  .advanced-label{
    text-align: right;
  }
  .advanced-row{
    width: 100%;
    margin-bottom: 20px;
  }
  .spaced-row {
    margin-bottom: 16px;
  }
  .custom-modal .ant-modal-body {
    max-height: 400px; 
    overflow-y: auto; 
  }

  .scrollable-content {
    max-height: 350px; 
    overflow-y: auto; 
  }
</style>